import axios from 'axios';
import { ENDPOINTS } from '../constants/endpoints';
import {
  ReassignHistoryRow, ReassignResult, ReassignType, SalesTeamsOverview,
} from '../interfaces/sales/salesTeam.interface';

/** S0: Sales Teams setup and the reassign action. Every setup call returns the refreshed overview. */
export const SalesTeamService = {
  overview: async (institutionId: string): Promise<SalesTeamsOverview> =>
    (await axios.get(ENDPOINTS.SALES_TEAMS.OVERVIEW(institutionId))).data,
  createDepartment: async (institutionId: string, name: string): Promise<SalesTeamsOverview> =>
    (await axios.post(ENDPOINTS.SALES_TEAMS.DEPARTMENTS(institutionId), { name })).data,
  renameDepartment: async (institutionId: string, id: string, name: string, active = true): Promise<SalesTeamsOverview> =>
    (await axios.put(ENDPOINTS.SALES_TEAMS.DEPARTMENT(institutionId, id), { name, active })).data,
  deleteDepartment: async (institutionId: string, id: string): Promise<SalesTeamsOverview> =>
    (await axios.delete(ENDPOINTS.SALES_TEAMS.DEPARTMENT(institutionId, id))).data,
  addHead: async (institutionId: string, id: string, userId: string): Promise<SalesTeamsOverview> =>
    (await axios.post(ENDPOINTS.SALES_TEAMS.HEADS(institutionId, id), { userId })).data,
  removeHead: async (institutionId: string, id: string, userId: string): Promise<SalesTeamsOverview> =>
    (await axios.delete(ENDPOINTS.SALES_TEAMS.HEAD(institutionId, id, userId))).data,
  createTeam: async (institutionId: string, departmentId: string, name: string): Promise<SalesTeamsOverview> =>
    (await axios.post(ENDPOINTS.SALES_TEAMS.TEAMS(institutionId), { departmentId, name })).data,
  renameTeam: async (institutionId: string, id: string, departmentId: string, name: string, active = true): Promise<SalesTeamsOverview> =>
    (await axios.put(ENDPOINTS.SALES_TEAMS.TEAM(institutionId, id), { departmentId, name, active })).data,
  deleteTeam: async (institutionId: string, id: string): Promise<SalesTeamsOverview> =>
    (await axios.delete(ENDPOINTS.SALES_TEAMS.TEAM(institutionId, id))).data,
  addManager: async (institutionId: string, id: string, userId: string): Promise<SalesTeamsOverview> =>
    (await axios.post(ENDPOINTS.SALES_TEAMS.MANAGERS(institutionId, id), { userId })).data,
  removeManager: async (institutionId: string, id: string, userId: string): Promise<SalesTeamsOverview> =>
    (await axios.delete(ENDPOINTS.SALES_TEAMS.MANAGER(institutionId, id, userId))).data,
  addMember: async (institutionId: string, id: string, userId: string): Promise<SalesTeamsOverview> =>
    (await axios.post(ENDPOINTS.SALES_TEAMS.MEMBERS(institutionId, id), { userId })).data,
  removeMember: async (institutionId: string, id: string, userId: string): Promise<SalesTeamsOverview> =>
    (await axios.delete(ENDPOINTS.SALES_TEAMS.MEMBER(institutionId, id, userId))).data,

  /** Hand a record to any active employee of the institution, or unassign it (toUserId null). */
  reassign: async (type: ReassignType, id: string, toUserId: string | null, note?: string): Promise<ReassignResult> =>
    (await axios.post(ENDPOINTS.SALES_SCOPE.REASSIGN(type, id), { toUserId, note: note?.trim() || undefined })).data,
  reassignHistory: async (institutionId: string, type: ReassignType, id: string): Promise<ReassignHistoryRow[]> =>
    (await axios.get(ENDPOINTS.SALES_SCOPE.HISTORY(institutionId, type, id))).data,
};
